import React, {FC, useState} from 'react';
import styled from 'styled-components';

import {OverrideMergeValues} from '../../../../../../../../src/store/data/cards/cardsActions';
import {AsyncHandlerOf, Handler} from '../../../../../../../shared/helpers/src/react/reactHelpers';
import {MergeContactsSidePanelContentContainer} from './mergeContactsSidePanelContentContainer';
import {MergeContactsSidePanelFooterContainer} from './mergeContactsSidePanelFooterContainer';
import {MergeContactsSidePanelHeaderContainer} from './mergeContactsSidePanelHeaderContainer';

/*
 * Props.
 */

interface MergeContactsSidePanelProps {
  onMergeAsync: AsyncHandlerOf<OverrideMergeValues | undefined>;
  onMergeSuccess: Handler;
}

/*
 * Styles.
 */

const StyledMergeContactsSidePanelContainerDiv = styled.div`
  display: flex;
  flex-flow: column;
  height: 100%;
`;

/*
 * Component.
 */

export const MergeContactsSidePanel: FC<MergeContactsSidePanelProps> = (props) => {
  const {onMergeAsync, onMergeSuccess} = props;

  const [isMerging, setIsMerging] = useState(false);
  const [overrideMergeValues, setOverrideMergeValues] = useState<OverrideMergeValues>();

  const onMergeClick = async () => {
    setIsMerging(true);
    await onMergeAsync(overrideMergeValues);
    onMergeSuccess();
    setIsMerging(false);
  };

  return (
    <StyledMergeContactsSidePanelContainerDiv>
      <MergeContactsSidePanelHeaderContainer />
      <MergeContactsSidePanelContentContainer
        isMerging={isMerging}
        overrideMergeValues={overrideMergeValues}
        setOverrideMergeValues={setOverrideMergeValues}
      />
      <MergeContactsSidePanelFooterContainer onMergeClick={onMergeClick} isMerging={isMerging} />
    </StyledMergeContactsSidePanelContainerDiv>
  );
};
